var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "power-management" },
    [
      _c("el-card", [
        _c(
          "div",
          {
            staticClass: "card-header",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("span", [_vm._v("安装运力管理")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "header-actions" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.handleAdd } },
                  [_vm._v(" 新增安装")]
                ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search-box" },
          [
            _c("el-input", {
              staticStyle: { width: "150px" },
              attrs: { placeholder: "关键词", clearable: "" },
              model: {
                value: _vm.searchForm.keyword,
                callback: function ($$v) {
                  _vm.$set(_vm.searchForm, "keyword", $$v)
                },
                expression: "searchForm.keyword",
              },
            }),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary", loading: _vm.searchLoading },
                on: { click: _vm.handleSearch },
              },
              [_vm._v("查询")]
            ),
            _vm._v(" "),
            _c("el-button", { on: { click: _vm.resetSearch } }, [
              _vm._v("重置"),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-section" }, [
          _c("div", { staticClass: "section-title" }, [_vm._v("运力概览")]),
          _vm._v(" "),
          _c("div", { staticClass: "stats-cards" }, [
            _c("div", { staticClass: "stats-card total" }, [
              _c("div", { staticClass: "stats-icon" }, [
                _c("i", { staticClass: "el-icon-s-tools" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stats-content" }, [
                _c("div", { staticClass: "stats-number" }, [
                  _vm._v(_vm._s(_vm.statistics.totalInstallers)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stats-label" }, [
                  _vm._v("总安装师傅"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-card available" }, [
              _c("div", { staticClass: "stats-icon" }, [
                _c("i", { staticClass: "el-icon-success" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stats-content" }, [
                _c("div", { staticClass: "stats-number" }, [
                  _vm._v(_vm._s(_vm.statistics.availableInstallers)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stats-label" }, [
                  _vm._v("可用安装师傅"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-card orders" }, [
              _c("div", { staticClass: "stats-icon" }, [
                _c("i", { staticClass: "el-icon-s-order" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stats-content" }, [
                _c("div", { staticClass: "stats-number" }, [
                  _vm._v(_vm._s(_vm.statistics.todayOrders)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stats-label" }, [
                  _vm._v("今日安装订单"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stats-card pending" }, [
              _c("div", { staticClass: "stats-icon" }, [
                _c("i", { staticClass: "el-icon-time" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stats-content" }, [
                _c("div", { staticClass: "stats-number" }, [
                  _vm._v(_vm._s(_vm.statistics.pendingOrders)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stats-label" }, [
                  _vm._v("待分配订单"),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-section" },
          [
            _c("div", { staticClass: "section-title" }, [
              _c("span", [_vm._v("安装师傅情况")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: {
                    "margin-left": "auto",
                    display: "flex",
                    "align-items": "center",
                  },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "150px", "margin-right": "10px" },
                    attrs: {
                      type: "date",
                      placeholder: "选择日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    on: {
                      change: function () {
                        _vm.installerPagination.page = 1
                      },
                    },
                    model: {
                      value: _vm.installerSearchDate,
                      callback: function ($$v) {
                        _vm.installerSearchDate = $$v
                      },
                      expression: "installerSearchDate",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", icon: "el-icon-refresh" },
                      on: {
                        click: function ($event) {
                          return _vm.loadInstallerList()
                        },
                      },
                    },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.installerLoading,
                    expression: "installerLoading",
                  },
                ],
                staticStyle: {
                  width: "100%",
                  "margin-bottom": "20px",
                  "font-size": "16px",
                },
                attrs: {
                  data: _vm.installerList,
                  border: "",
                  stripe: "",
                  "max-height": _vm.tableHeight,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "操作", width: "120", fixed: "left" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleEditInstaller(scope.row)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { color: "#f56c6c" },
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDeleteInstaller(scope.row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "userName",
                    label: "姓名",
                    "min-width": "150",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "phone", label: "电话", "min-width": "150" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "status", label: "接单状态", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.status === 0
                            ? _c("el-tag", { attrs: { type: "success" } }, [
                                _vm._v("接单"),
                              ])
                            : scope.row.status === 1
                            ? _c("el-tag", { attrs: { type: "warning" } }, [
                                _vm._v("休息"),
                              ])
                            : _c("el-tag", { attrs: { type: "info" } }, [
                                _vm._v("未知"),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "taskDate",
                    label: "接单日期",
                    "min-width": "120",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.taskDate
                                  ? _vm.formatDate(scope.row.taskDate)
                                  : "-"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "taskTime",
                    label: "时段",
                    "min-width": "140",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.taskTime === "08:00-12:00"
                            ? _c(
                                "el-tag",
                                { attrs: { type: "warning", size: "mini" } },
                                [_vm._v("上午(08:00-12:00)")]
                              )
                            : scope.row.taskTime === "12:00-18:00"
                            ? _c(
                                "el-tag",
                                { attrs: { type: "success", size: "mini" } },
                                [_vm._v("下午(12:00-18:00)")]
                              )
                            : scope.row.taskTime === "08:00-18:00"
                            ? _c(
                                "el-tag",
                                { attrs: { type: "primary", size: "mini" } },
                                [_vm._v("全天(08:00-18:00)")]
                              )
                            : _c("span", [
                                _vm._v(_vm._s(scope.row.taskTime || "-")),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "remark", label: "备注", "min-width": "200" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.installerTotal > 0
              ? _c("el-pagination", {
                  staticStyle: { "margin-top": "15px", "text-align": "right" },
                  attrs: {
                    "current-page": _vm.installerPagination.page,
                    "page-sizes": [10, 20, 50, 100],
                    "page-size": _vm.installerPagination.pageSize,
                    total: _vm.installerTotal,
                    layout: "total, sizes, prev, pager, next, jumper",
                  },
                  on: {
                    "size-change": _vm.handleInstallerSizeChange,
                    "current-change": _vm.handleInstallerCurrentChange,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-section" },
          [
            _c("div", { staticClass: "section-title" }, [
              _c("span", [_vm._v("安装师傅排班")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: {
                    "margin-left": "auto",
                    display: "flex",
                    "align-items": "center",
                  },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "150px", "margin-right": "10px" },
                    attrs: {
                      type: "date",
                      placeholder: "选择日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.scheduleSearchDate,
                      callback: function ($$v) {
                        _vm.scheduleSearchDate = $$v
                      },
                      expression: "scheduleSearchDate",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", icon: "el-icon-refresh" },
                      on: {
                        click: function ($event) {
                          return _vm.loadScheduleList()
                        },
                      },
                    },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.scheduleLoading,
                    expression: "scheduleLoading",
                  },
                ],
                staticStyle: {
                  width: "100%",
                  "margin-bottom": "20px",
                  "font-size": "16px",
                },
                attrs: {
                  data: _vm.pagedScheduleList,
                  border: "",
                  "max-height": _vm.tableHeight,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "操作", width: "80", fixed: "left" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              staticStyle: { color: "#f56c6c" },
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDeleteScheduleUser(scope.row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "name",
                    label: "安装师傅",
                    "min-width": "120",
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.scheduleDateRange, function (dateItem) {
                  return _c(
                    "el-table-column",
                    {
                      key: dateItem.key,
                      attrs: { label: dateItem.label, align: "center" },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "上午",
                          "min-width": "80",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      class: _vm.getScheduleClass(
                                        scope.row[dateItem.key + "_上午"]
                                      ),
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          scope.row[dateItem.key + "_上午"] ||
                                            "空闲"
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "下午",
                          "min-width": "80",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      class: _vm.getScheduleClass(
                                        scope.row[dateItem.key + "_下午"]
                                      ),
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          scope.row[dateItem.key + "_下午"] ||
                                            "空闲"
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm.scheduleTotal > 0
              ? _c("el-pagination", {
                  staticStyle: { "margin-top": "15px", "text-align": "right" },
                  attrs: {
                    "current-page": _vm.schedulePagination.page,
                    "page-sizes": [10, 20, 50, 100],
                    "page-size": _vm.schedulePagination.pageSize,
                    total: _vm.scheduleTotal,
                    layout: "total, sizes, prev, pager, next, jumper",
                  },
                  on: {
                    "size-change": _vm.handleScheduleSizeChange,
                    "current-change": _vm.handleScheduleCurrentChange,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              !_vm.isEdit
                ? _c(
                    "el-form-item",
                    { attrs: { label: "安装师傅", prop: "userId" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            gap: "8px",
                          },
                        },
                        [
                          _vm._l(_vm.installerUserList, function (item) {
                            return _c(
                              "el-tag",
                              {
                                key: item,
                                staticStyle: { "margin-right": "2px" },
                              },
                              [_vm._v(_vm._s(item))]
                            )
                          }),
                          _vm._v(" "),
                          _c("el-button", { on: { click: _vm.onUserSelect } }, [
                            _vm._v("选择"),
                          ]),
                        ],
                        2
                      ),
                    ]
                  )
                : _c("el-form-item", { attrs: { label: "安装师傅" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.form.userName))]),
                  ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "日期", prop: "taskDate" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "选择日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.form.taskDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "taskDate", $$v)
                      },
                      expression: "form.taskDate",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "时段", prop: "taskTime" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.taskTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "taskTime", $$v)
                        },
                        expression: "form.taskTime",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "上午" } }, [
                        _vm._v("上午"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "下午" } }, [
                        _vm._v("下午"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "全天" } }, [
                        _vm._v("全天"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("接单")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("休息")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "请输入备注",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("UserSelect", {
        ref: "userSelect",
        attrs: { "show-user-select": _vm.showUserSelect },
        on: {
          close: _vm.onUserSelectClose,
          "select-user-callBack": _vm.selectUserCallBack,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }